document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.multicoll_card_main').forEach(function(collcard) {
    const swiperEl = collcard.querySelector('.multicoll_card_swiper');
    if (!swiperEl) return;
    const prevBtn = collcard.querySelector('.multicoll_card_swiper_button_prev');
    const nextBtn = collcard.querySelector('.multicoll_card_swiper_button_next');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function () {
            checkScrollable(this);
        },
        resize: function () {
            checkScrollable(this);
        },
     },
    });

    function checkScrollable(swiperInstance) {
        const mainwrapp = collcard.querySelector('.multicoll_card_content');
        const wrapper = swiperInstance.wrapperEl;
        const container = swiperInstance.el;

        if (wrapper.scrollWidth > container.clientWidth) {
            mainwrapp.classList.add("multicoll_card_main_scrollable");
            mainwrapp.classList.remove("dia_slider_not_scrollable");
        } else {
            mainwrapp.classList.remove("multicoll_card_scrollable");
            mainwrapp.classList.add("multicoll_card_not_scrollable");
        }
    }

  });
});